/* eslint-disable */
require('./BAROMETER')
require('./bin')
require('./clear')
require('./duplicate')
require('./EN')
require('./ES')
require('./eye')
require('./FR')
require('./idalgo')
require('./IT')
require('./multiproducts')
require('./pen')
require('./PLAYERLIST')
require('./save')
require('./search')



// WEBPACK FOOTER //
// ./src/components/icons/index.js